<template>
	<div class="EmailResetPassword">
		<el-dialog :visible.sync="dialogVisible" :close-on-click-modal="false">
			<div class="EmailResetPassword_center_div">
				<div v-if="!show_resend_link_section">
					<h2>Password Reset</h2>
					<div
						class="form-group1 w-95p inline-block"
						:class="{ 'not-empty1': email.length }"
					>
						<input
							v-model="email"
							v-validate="'required|email'"
							type="text"
							class="form-control1"
							name="Email"
						/>
						<label for="user" class="animated-label1">
							Enter Email
						</label>
					</div>
					<span class="text-red-dark text-xs">
						{{ errors.first("Email") }}
					</span>
					<div class="Confirm-btn-section">
						<button class="confirm-button" @click="sendResetPasswordLink">
							Confirm
						</button>
					</div>
				</div>
				<div v-if="show_resend_link_section" class="messsage-section">
					<p>Visit your register email address to activate your account.</p>
					<div class="link-section">
						<p v-if="show_disabled_link" else class="disabled-link">
							Resend activation link
						</p>
						<p v-else class="enabled-link" @click="ResendResetPasswordLink">
							Resend activation link
						</p>
					</div>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import { serverAddr } from "../../networkConfig";
import { EmailResetPasswordNC } from "../../../mixins/EmailResetPasswordNC";

export default {
	name: "EmailResetPassword",
	mixins: [EmailResetPasswordNC],
	props: [],
	data() {
		return {
			email: "",
			dialogVisible: true,
			validation_message: false,
			show_resend_link_section: false,
			show_disabled_link: false
		};
	},
	methods: {
		// validateEmail: function(email) {
		// 	let lastAtPos = email.lastIndexOf("@");
		// 	let lastDotPos = email.lastIndexOf(".");
		// 	if (
		// 		!(
		// 			lastAtPos < lastDotPos &&
		// 			lastAtPos > 0 &&
		// 			email.indexOf("@@") === -1 &&
		// 			lastDotPos > 2 &&
		// 			email.length - lastDotPos > 2
		// 		)
		// 	) {
		// 		this.validation_message = true;
		// 		// return (true);
		// 	} else {
		// 		this.validation_message = false;
		// 		// return (false);
		// 	}
		// },
		// sendResetPasswordLink: function() {
		// 	if (this.email !== "" && this.validation_message === false) {
		// 		serverAddr
		// 			.post("users/password/reset/", {
		// 				email: this.email
		// 			})
		// 			.then(this.postPasswordResetNC)
		// 			.catch(function(error) {
		// 				console.log(error);
		// 			});
		// 	} else {
		// 		this.validation_message = true;
		// 	}
		// },
		sendResetPasswordLink: function() {
			this.$validator.validateAll().then(result => {
				if (result) {
					serverAddr
						.post("users/password/reset/", {
							email: this.email
						})
						.then(this.postPasswordResetNC)
						.catch(function(error) {
							console.log(error);
						});
				}
			});
		},

		ResendResetPasswordLink: function() {
			serverAddr
				.post("users/password/reset/", {
					email: this.email
				})
				.then(this.postRsendPasswordResetLinkNC)
				.catch(error => {
					this.$notify.error({
						title: "Error",
						message: JSON.parse(error.response.data).email[0],
						type: "Error"
					});
				});
		}
	}
};
</script>

<style lang="scss" scoped>
@import "./EmailResetPassword.scss";
</style>
<style>
.EmailResetPassword .el-icon-close {
	display: none;
}
.EmailResetPassword .el-dialog {
	height: auto;
	max-height: 90%;
	max-width: 650px;
	width: 680px;
	margin-top: 0 !important;
}
@media screen and (max-width: 700px) {
	.EmailResetPassword .el-dialog {
		width: 90%;
	}
}

.EmailResetPassword .el-dialog__body {
	padding: 0 0 30px 0;
}
.EmailResetPassword .el-dialog__header {
	@apply p-0;
}
.EmailResetPassword .EmailResetPassword_button {
	text-align: right !important;
}
.EmailResetPassword .el-button--primary {
	background-color: #2c9bce;
	padding: 13px 12px 11px;
	border-radius: 2px;
	font-size: 15px;
	cursor: pointer;
	letter-spacing: 0.02em;
	transition: all 0.2s ease;
	color: #fff;
	border: none;
}
@media screen and (max-width: 576px) {
	.EmailResetPassword .EmailResetPassword_button {
		margin-top: 20px;
		text-align: center !important;
	}
}
</style>
